import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslatePipe } from '@ngx-translate/core';
import { FormField } from '../form-field.component';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  imports: [ReactiveFormsModule, MatSlideToggleModule, TranslatePipe, MatFormField, MatInput, MatHint, MatLabel],
  selector: 'app-form-field-toggle',
  templateUrl: './form-field-toggle.component.html',
  styleUrls: ['./form-field-toggle.component.scss'],
  standalone: true,
})
export class FormFieldToggleComponent extends FormField {
  @Input()
  labelPosition: 'before' | 'after' = 'after';
  @Input()
  floatRight = true;

  toggleChanged(event: MatSlideToggleChange): void {
    this.formGroup.controls[this.field].setValue(event.checked);
  }
}
